import { Component, OnInit } from "@angular/core";
import { FooterNavigationBarComponent, MenuItem } from "../../../shared/components/footer-navigation-bar/footer-navigation-bar.component";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { BqaRole, RoleSwitchService } from "../../shared/services/role-switch.service";

@Component({
  standalone: true,
  selector: "app-cm-root",
  imports: [FooterNavigationBarComponent, RouterModule],
  templateUrl: "./cm-root.component.html",
  styleUrl: "./cm-root.component.scss"
})
export class CmRootComponent implements OnInit {

  selectedTab = "schedule";

  tabs: MenuItem[] = [];

  private readonly baseTabs: MenuItem[] = [
    {
      tabName: "schedule",
      itemText: "Schedule",
      itemIconUri: "assets/icons/calendar-today.svg",
      route: "cm/schedule"
    },
    {
      tabName: "lots",
      itemText: "All my lots",
      itemIconUri: "assets/icons/holiday-village-outline-rounded.svg",
      route: "cm/all-my-lots"
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleSwitchService: RoleSwitchService
  ) {
  }

  ngOnInit(): void {
    this.tabs = this.buildTabs();

    const currentRouteWithoutLeadingSlash = this.router.url.slice(1);
    const matchingTab = this.tabs.find(tab => currentRouteWithoutLeadingSlash.startsWith(tab.route ?? ""));
    if (matchingTab) {
      this.selectedTab = matchingTab.tabName;
    }
  }

  onTabChanged(newTab: MenuItem) {
    this.selectedTab = newTab.tabName;
    this.router.navigate([newTab.route ?? ""]);
  }

  private buildTabs(): MenuItem[] {
    if (!this.roleSwitchService.hasBothAssignableRoles()) {
      return [...this.baseTabs];
    }

    return [
      ...this.baseTabs,
      this.roleSwitchService.getProfileTab(BqaRole.ConstructionManager)
    ];
  }

}
